import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/pendulum-period-calculator',
  component: () => import('../../routes/PendulumPeriodCalculator.svelte'),
  card: {
    id: 'pendulum-period-calculator',
    title: 'Pendulum Period',
    description: 'Calculate the period, frequency, and angular frequency of a simple pendulum using T = 2π√(L/g). Supports planetary gravity presets.',
    icon: 'swing_right',
    iconBgClass: 'bg-purple-50',
    iconTextClass: 'text-purple-600',
    href: '/pendulum-period-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'Pendulum Period Calculator – Calculate Oscillation Time',
    description:
      'Free pendulum period calculator to find T, frequency, and angular frequency using the physics formula T = 2π√(L/g). Includes planetary gravity presets for Earth, Moon, Mars.',
  },
};

export default meta;